import cookies from './util.cookies'
import title from './util.title'

const util = {
  cookies,
  title
}

export default util
